import { render, staticRenderFns } from "./UsuarioFotoNome.vue?vue&type=template&id=307935bb"
import script from "./UsuarioFotoNome.vue?vue&type=script&lang=ts"
export * from "./UsuarioFotoNome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports